/**
 * Designs queries
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const styleQuery = gql`
  query getStyle($designId: String!) {
    design: sharedDesignShortId(designId: $designId) {
      id
      name
      flatlockColor: flatlock
      bindingColor: binding_color
      bibBraceColor: bib_brace_color
      zipperColor: zipper_color
      zipper2Color: zipper2_color
      product {
        id
        code
        name
        obj
        mtl
        label
        glbEnabled: glb_enabled
        bumpMap: bump_map
        flatlock
        binding {
          white
          black
        }
        zipper {
          white
          black
        }
        zipper2 {
          white
          black
        }
        bibBrace {
          white
          black
        }
      }
      svg: output_svg
      canvas
    }
  }
`

export const getFonts = graphql(
  gql`
    query GetFonts {
      fonts: getFonts {
        id
        family
        active
      }
    }
  `,
  { name: 'fontsData' }
)

export const getVariantsFromDesign = gql`
  query getVariantsDesign($shortId: String!) {
    getVariantsDesign(shortId: $shortId) {
      id: short_id
      name
      icon
      default: is_default
      obj
      mtl
      glb
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Designs/data.ts